export default __webpack_public_path__ + "static/media/avalanche.00b293e5.svg";